export default __webpack_public_path__ + "static/media/next-aircare.f8ef09ee.jpg";